import IComponent from "components/commons/IComponent";
import "./MainPage.scoped.css";
import MapView from "../MapViews/MapView";
import LeftPanel from "./LeftPanel";
import MapInfoBar from "./MapInfoBar";
import { connect } from "react-redux";
import { enableCompactMode, toggleMapType } from "store/globalSlice";
import React from "react";
import AlertDialog from "components/commons/AlertDialog";
import Mode3DQueue from "components/MapViews/Mode3DQueue";
import BookmarkUtils from "utils/BookmarkUtils";

import openFromUrlForResult from "components/ZoomTo/openFromUrlForResult";
let isCompactMode = false;
let compactModeSlope;
let layerStatusBookmark = null;
class MainPage extends IComponent {
  constructor(props) {
    super(props);
    this.state = {
      menuCollapsed: false,
      mapViewRef: null,
      activeMenuItem: null,
      menuIndex: null,
      dialogSetup: {},
      isUserValid: false,
      isMapViewReady: false,
      tempPanel: undefined,
    };
    console.debug("MainPage created!");
    compactModeSlope = openFromUrlForResult.openFromUrl();
    isCompactMode = typeof compactModeSlope !== "undefined";
  }
  componentDidMount() {
    console.debug("MainPage mounted!");
    this.chageUiColor();
    Mode3DQueue.addLog();
  }
  componentWillUnmount() {}
  chageUiColor() {
    const styleProps = document.documentElement.style;
    const colorValue = this.props.mapType;
    styleProps.setProperty("--uiColor", `var(--uiColor_${colorValue}D)`);
    styleProps.setProperty("--uiColor2", `var(--uiColor2_${colorValue}D)`);
    styleProps.setProperty("--uiColor3", `var(--uiColor3_${colorValue}D)`);
    styleProps.setProperty("--uiColor4", `var(--uiColor4_${colorValue}D)`);
    styleProps.setProperty("--uiColor5", `var(--uiColor5_${colorValue}D)`);
    styleProps.setProperty("--iconColor", `var(--iconColor_${colorValue}D)`);
    styleProps.setProperty("--iconColor2", `var(--iconColor2_${colorValue}D)`);
    styleProps.setProperty(
      "--iconRemoveColor",
      `var(--iconRemoveColor_${colorValue}D)`
    );
  }
  async mapCreatedCallback(view) {
    this.chageUiColor();
    this.setState({ mapViewRef: view, isMapViewReady: true, menuIndex: 0 });
    BookmarkUtils.prepareLayerHashTable(this.$config.mapList);
    if (isCompactMode) {
      this.showDialog({
        isOpen: true,
        title: "Searching...",
        content: (
          <div>
            <span className="icn_loading" />
            Searching for the slope, please wait...
          </div>
        ),
      });
      await openFromUrlForResult.searchForSlope(compactModeSlope, view);
      this.showDialog({
        isOpen: false,
      });
      return;
    } else if (!!layerStatusBookmark) {
      BookmarkUtils.fromJson(view, layerStatusBookmark);
    }
    let defaultLayerClone = JSON.parse(
      JSON.stringify(this.$config.DEFAULT_LAYERS[`${this.props.mapType}D`])
    );
    this.$config.DEFAULT_LAYERS[
      `${this.props.mapType}D_OBJ`
    ] = defaultLayerClone;
    if (isCompactMode) delete defaultLayerClone.overlays;
    let func = function(list, mapList, key) {
      list.forEach(
        (j) =>
          (j[0] = (key === "layer3D" ? mapList[j[3]] : mapList).find(
            (k) => k.title === j[0]
          ))
      );
    };
    Object.keys(defaultLayerClone).forEach((i) => {
      func(defaultLayerClone[i], this.$config.mapList[i], i);
    });
    defaultLayerClone.noZoom = 1;
    console.debug(defaultLayerClone);
    BookmarkUtils.fromJson(view, defaultLayerClone, true);
  }
  createPanel() {
    let { isMapViewReady, activeMenuItem, tempPanel } = this.state;
    let component = tempPanel || activeMenuItem?.component;
    return isMapViewReady && component ? (
      React.createElement(
        component,
        {
          mapView: this.state.mapViewRef,
          mapView2: this.state.mapViewRef2,
          mapType: this.props.mapType,
          switchPanel: this.childSwitchPanel.bind(this),
          showDialog: this.showDialog.bind(this),
          reduxCallProxy: this.props.reduxCallProxy,
          reduxStore: this.props.reduxStore,
        },
        null
      )
    ) : (
      <div />
    );
  }
  childSwitchPanel(index, tempPanel) {
    this.setState({
      menuIndex: index,
      tempPanel,
    });
  }
  showDialog(dialogSetup) {
    this.setState({ dialogSetup });
  }
  switchModeFunc() {
    // Destroy all panel components before really switching to a new map mode
    this.setState({
      isMapViewReady: false,
    });
    /**
     * About layer status restoration:
     * 1. Take a snapshot of the current layer status
     * 2. Switch map mode
     * 3. Restore the layer status from the snapshot
     * 4. Get the default layer status bookmark JSON
     * 5. Replace the layers in the default status with the actual layer hashcodes
     * 6. Apply the default layer status bookmark (But preserve the status from the snapshot)
     */
    layerStatusBookmark = BookmarkUtils.toJson(
      this.state.mapViewRef,
      !this.props.mapType == 3,
      false
    );
    delete layerStatusBookmark.basemaps;
    this.props.changeMapType();
  }
  render() {
    console.debug("MainPage Update");
    const { mapType } = this.props;
    let {
      menuCollapsed,
      mapViewRef,
      activeMenuItem,
      menuIndex,
      isMapViewReady,
    } = this.state;

    let changeMapType = this.switchModeFunc.bind(this);

    return (
      <div className={`MainPage ${menuCollapsed ? "collapsed" : ""}`}>
        {isMapViewReady && (
          <LeftPanel
            menuItemClickedCallback={(activeMenuItem, menuIndex) => {
              this.setState({
                menuIndex,
                activeMenuItem,
                menuCollapsed: false,
                tempPanel: undefined,
              });
            }}
            collapsed={menuCollapsed}
            activeIndex={menuIndex}
            isCompactMode={isCompactMode}
          />
        )}
        <div
          className="panelArea"
          style={isCompactMode ? { display: "none" } : {}}
        >
          {this.createPanel()}
        </div>
        <div className="RightView">
          <div
            className="collapseButton"
            style={{ display: isCompactMode ? "none" : "flex" }}
            onClick={() => {
              this.setState({ menuCollapsed: !menuCollapsed });
            }}
          >
            <span
              style={{ color: "var(--uiColor)" }}
              className={`icn_${!menuCollapsed ? "left" : "right"}`}
            />
          </div>
          {activeMenuItem?.name == "Split" && (
            <MapView
              splitMap={true}
              mapType={this.props.reduxStore.global.map2Type}
              typeToggle={changeMapType}
              onMapCreatedCallback={(view) => {
                this.setState({ mapViewRef2: view });
              }}
              showDialog={this.showDialog.bind(this)}
              reduxStore={this.props.reduxStore}
              reduxCallProxy={this.props.reduxCallProxy}
            />
          )}
          {activeMenuItem?.name == "Split" && <div className="SplitMapLine" />}
          <MapView
            mapType={isCompactMode ? 3 : mapType}
            typeToggle={changeMapType}
            onMapCreatedCallback={(view) => this.mapCreatedCallback(view)}
            switchPanel={this.childSwitchPanel.bind(this)}
            showDialog={this.showDialog.bind(this)}
            isCompactMode={isCompactMode}
            isSplitMapActivated={activeMenuItem?.name == "Split"}
            reduxStore={this.props.reduxStore}
            reduxCallProxy={this.props.reduxCallProxy}
          />
        </div>
        <MapInfoBar mapType={mapType} mapView={mapViewRef} />
        <AlertDialog dialogSetup={this.state.dialogSetup} />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    changeMapType: () => dispatch(toggleMapType()),
    reduxCallProxy: function(reducer, payLoad) {
      dispatch(reducer(payLoad));
    },
  };
};

const mapStateToProps = function(state, ownProps) {
  // console.debug("mapStateToProps", JSON.stringify(state));
  return { mapType: state.global.mapType, reduxStore: state };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MainPage);
